import * as yup from 'yup';

export const subscribeSchema = yup.object().shape({
  email: yup.string().email().trim().required('email is required'),
  name: yup.string().trim().required('name is required'),
  message: yup.string().required('message is required'),
});
